/*eslint-disable*/
import React, { useState } from 'react'
import {
    PageWrapper,
    PageFooter,
    H1WithBack,
    Flex,
} from '../../styling/GlobalStyles'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../components/NavBar/NavBar'
import { Pagination } from 'components/Pagination/Pagination'
import { AppDispatch, RootState } from 'store'
import { setConfirmModal } from 'features/global/globalSlice'
import { Options } from 'components/Options/Options'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { getParams, handlePagination } from 'utils/helpers'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import useQueryPagination from 'hooks/useQueryPagination'
import { checkOut, clearAccommodationUsers, getAccommodationUsers } from 'features/accommodation/accommodationSlice'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { ISelectValue } from 'constants/globalTypes'

export const AccommodationUsers: React.FC = () => {
    const { data, totalPages } = useSelector((store: RootState) => store.accomodation.accomodationUsers)
    const dispatch = useDispatch<AppDispatch>()
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))

    useQueryPagination({ fetchFunctions: [getAccommodationUsers], cleanUpFunctions: [clearAccommodationUsers], params })

    const handleCheckOut = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(checkOut(id))
                },
                word: 'check-out this user',
            }),
        )
    }

    const handleFilter = (v: ISelectValue) => {
        if (!v?.value) {
            setParams(prev => {
                const copy = structuredClone(prev)
                copy.isAccommodationAssigned = null
                return copy
            })
            return
        }
        setParams(prev => ({ ...prev, isAccommodationAssigned: v.value == 1 ? true : false }))
    }

    const columns: IHonestTableColumn<any>[] = [
        { id: 'type', header: 'TYPE', cell: (item) => (item?.type == 1 ? 'Employee' : 'Guest') },
        {
            id: 'id',
            header: 'ID',
            cell: (item) => {
                const type = item.type == 1 ? 'user' : 'guest'
                return item[type]?.identificationNumber ?? '/'
            },
        },
        {
            id: 'name',
            header: 'NAME',
            cell: (item) => {
                const type = item.type == 1 ? 'user' : 'guest'
                return item[type].firstName + ' ' + item[type].lastName
            },
        },
        {
            id: 'accommodation',
            header: 'ACCOMMODATION',
            cell: (item) => {
                const type = item.type == 1 ? 'user' : 'guest'
                return item[type].accommodation ? item[type].accommodation.name : '/'
            },
        },
        {
            id: 'actions',
            header: '',
            align: 'right',
            cell: (item) => (
                <span onClick={(e) => e.stopPropagation()}>
                    <Options item={item} title='Accommodation Users' openModal={handleCheckOut} />
                </span>
            ),
        },
    ]


    return (
        <>
            <NavBar setParams={setParams} params={params} input />
            <PageWrapper>
                <Flex width='100%' between >
                    <H1WithBack mb='1' arrow title=' Accommodation Users' />
                    <HonestSelectInput defaultValue={params.isAccommodationAssigned ? (String(params.isAccommodationAssigned) == 'true' ? 1 : 2) : null} width='300px' labelText='Accomodation Status' onChange={handleFilter} options={[{ value: 1, label: 'Assigned' }, { value: 2, label: 'Not Assigned' }]} />
                </Flex>
                {!data.length ? (
                    <NoItems title='Users' />
                ) : (
                    <HonestTable columns={columns} data={(data || []).map((r, i) => ({ ...r, id: i }))} keyField='id' />
                )}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
